import type { WorldState } from "../state";

/**
 * legacy: WrapBoundaryStrategy. Objects past an edge move one world-width/height to the
 * other side (a single step, not a modulo; exactly on the edge stays put).
 */
export function applyWrap(world: WorldState): void {
	const { width, height } = world.size;
	for (const e of world.entities) {
		if (e.pos.x < 0) e.pos.x += width;
		else if (e.pos.x > width) e.pos.x -= width;
		if (e.pos.y > height) e.pos.y -= height;
		else if (e.pos.y < 0) e.pos.y += height;
	}
}
